import { createSelector } from '@ngrx/store';
import { IImportFilesTableState } from '@app/pages/files/file-table/table-state/import-files-table.reducer';

export const importFilesTableState = state => state.importFilesTable;

export const fileSessionInfo = createSelector(
	importFilesTableState,
	(state: IImportFilesTableState) => state.importSessionInfo
);

export const selectPaginationOptions = createSelector(
	importFilesTableState,
	(state: IImportFilesTableState) => state.paginationOptions
);

export const selectFilterOptions = createSelector(
	importFilesTableState,
	(state: IImportFilesTableState) => state.filterOptions
);

export const tableIsInitializing = createSelector(
	importFilesTableState,
	(state: IImportFilesTableState) => state.tableIsInitializing
);

// ----- TABLE CONFIG
export const selectColumns = createSelector(
	importFilesTableState,
	(state: IImportFilesTableState) => state.tableConfig?.columns
);

export const selectTableConfig = createSelector(
	importFilesTableState,
	(state: IImportFilesTableState) => state.tableConfig
);

// ----

export const selectPaginationData = createSelector(
	importFilesTableState,
	(state: IImportFilesTableState) => state.filesPagination
);

export const totalFilesCount = createSelector(
	importFilesTableState,
	(state: IImportFilesTableState) => state.fileImportCounters?.totalCount
);

export const completedFilesCount = createSelector(
	importFilesTableState,
	(state: IImportFilesTableState) => state.fileImportCounters?.importConfirmedCount
);

export const selectCounters = createSelector(
	importFilesTableState,
	(state: IImportFilesTableState) => state.fileImportCounters
);

export const allFilePks = createSelector(
	importFilesTableState,
	(state: IImportFilesTableState) => state.allFilePks
);
